import { SortingType } from "../enums/SortingType";

export const getOrdering = (type: SortingType) => {
  switch (type) {
    case SortingType.Popular:
      return 1;
    case SortingType.Relevance:
      return 2;
    case SortingType.PublicationDate:
      return 3;
  }
};
